import React, { useEffect, useState } from "react";
import { MdOutlineArrowBackIosNew as LBtn, MdOutlineArrowForwardIos as RBtn } from 'react-icons/md';
import { FiMoreHorizontal as MoreIcon } from 'react-icons/fi';
import tableStyle from '../css/table.module.css';
import SettingsModal from '../Modal/settingsCustomModal';
import UpdateState from "./UpdateState";
import DeleteState from "./DeleteState";

interface State {
    StateId: number;
    StateName: string;
    CountryId?: number;
    Country: StateCountry;
}

interface StateCountry {
    CountryId: number;
    CountryName: string;
    Id: number;
    CreatedBy?: any;
    ModifiedBy?: any;
    UserIpAddress?: any;
    CreateDate: string;
    LastModified: string;
    ActiveStatus: boolean;
    IsApprovalRequired?: any;
    RouteId?: any;
    ApprovalTypeId?: any;
    IsDeleted: boolean;
}

interface CountryResponse {
    data: Country[];
}

interface Country {
    CountryId: number;
    CountryName: string;
}

interface ComponentProps {
    getStatesQuery: State[] | undefined;
    getCountryData: CountryResponse | undefined;
    countryIsLoading: boolean;
    countryIsError: boolean;
    getCountryErrorMessage: string;
}

const StateTable: React.FC<ComponentProps> = ({ getStatesQuery, getCountryData, countryIsError, countryIsLoading, getCountryErrorMessage }) => {
    const [activeData, setActiveData] = useState<any>([]);
    const [pageData, setPageData] = useState<any>([]);
    const [currentPage, setCurrentPage] = useState<number>(0);
    const [pageArr, setPageArr] = useState<any>([]);
    const [showMore, setShowMore] = useState<boolean>(false);
    const [showIndex, setShowIndex] = useState<any>(null);
    const [showSpan, setShowSpan] = useState<boolean>(false);
    const [spanIndex, setSpanIndex] = useState<null | number>(null);
    const [stateId, setStateId] = useState(0);
    const [countryId, setCountryId] = useState(0);
    const [stateName, setStateName] = useState('');
    const [openUpdateStateModal, setOpenUpdateStateModal] = useState(false);
    const [openDeleteStateModal, setOpenDeleteStateModal] = useState(false);

    const handleOpenUpdateStateModal = () => setOpenUpdateStateModal(true);
    const handleCloseUpdateStateModal = () => setOpenUpdateStateModal(false);

    const handleOpenDeleteStateModal = () => setOpenDeleteStateModal(true);
    const handleCloseDeleteStateModal = () => setOpenDeleteStateModal(false);

    const DATA_PER_PAGE = 10;

    const handlePrevous = () =>{

    }

    const handleNext = ()=>{

    }

    const handleMore = (index: number) => {
        if(index == showIndex){
            setShowIndex(null);
            setShowMore(false);
            return
        }
        setShowIndex(index);
        setShowMore(true);
    }

    const handleSpan = (index: number) => {
        if(index == spanIndex){
            setSpanIndex(null);
            setShowSpan(false);
            return
        }
        setSpanIndex(index);
        setShowSpan(true);
    }

    const handleUpdate = (data: State) => {
        setStateId(data?.StateId);
        setStateName(data?.StateName);
        setCountryId(data?.Country?.CountryId)
        handleOpenUpdateStateModal();
    }

    const handleDelete = (data: State) => {
        setStateId(data?.StateId);
        setStateName(data?.StateName);
        setCountryId(data?.Country?.CountryId)
        handleOpenDeleteStateModal();
    }

    const data = getStatesQuery;

    useEffect(() => {
        if(data && data?.length > 0){
            setActiveData(data);
            let lastPage = Math.ceil(data?.length / 10);
            let i = 0;
            let arr = [];

            for(i = 0; i < lastPage; i++){
                arr.push(i);
            }

            setPageArr(arr);
            setPageData(data?.slice(0, DATA_PER_PAGE));
    
        }
    },[data])

    useEffect(() => {
        if(activeData && activeData.length > 0){    
            let start = currentPage * DATA_PER_PAGE;
            let stop = start + DATA_PER_PAGE;
            setPageData(data?.slice(start, stop));  
        }
    },[currentPage])

    return (
        <div className={tableStyle.container}>
            <>
                <div style={{gridTemplateColumns:`repeat(3, 2.3fr) 0.2fr`}}>
                    <div>State</div>
                    <div>Country</div>
                    <div>Status</div>
                </div>
                <div>  
                   { 
                    pageData && pageData.length > 0 && pageData.map(( data: State, index: number) =>
                        <div key={index} style={{gridTemplateColumns:`repeat(3, 2.3fr) 0.2fr`}}>
                            <div onClick={()=>handleSpan(index)}>{data?.StateName}</div>
                            <div onClick={()=>handleSpan(index)}>{data?.Country?.CountryName}</div>
                            <div onClick={()=>handleSpan(index)}>{data?.Country?.IsDeleted === false ? 'Active' : 'Disabled'}</div>
                            <div> 
                                <span 
                                    className={`${tableStyle.moreSpan} ${index == showIndex ? `${tableStyle.activeMore}` : ''} `} 
                                    onClick={()=>handleMore(index)}
                                >
                                    <MoreIcon />
                                    {index == showIndex && showMore ? (
                                    <div>
                                        <div onClick={() => handleUpdate(data)}>Edit State</div>
                                        <div onClick={() => handleDelete(data)}>Delete State</div>
                                    </div>) : '' }
                                </span>
                            </div>
                        </div>
                    )}
                </div>
                <div className={tableStyle.pagination}>
                    <div>
                        <button className={`${tableStyle.lBtn} ${tableStyle.btn}`}><LBtn/></button>
                        {pageArr && pageArr.length > 0 && pageArr.map((ePage: number, index: number) => {

                            if(index <= 4 && currentPage <= 4) return (<span
                                style={ ePage == currentPage ? {backgroundColor : "var(--activeP-back)", color : "var(--white-color)"} : {} } 
                                key={ePage} 
                                onClick={() => setCurrentPage(ePage)}
                            >
                                {ePage + 1}
                            </span>)  

                            if(index == currentPage ) return (<span
                                style={ ePage == currentPage ? {backgroundColor : "var(--activeP-back)", color : "var(--white-color)"} : {} } 
                                key={ePage} 
                                onClick={() => setCurrentPage(ePage)}
                            >
                                {ePage + 1}
                            </span>)  

                            if(index >= pageArr.length - 3 && currentPage >= pageArr.length -3) return (<span
                                style={ ePage == currentPage ? {backgroundColor : "var(--activeP-back)", color : "var(--white-color)"} : {} } 
                                key={ePage} 
                                onClick={() => setCurrentPage(ePage)}
                            >
                                {ePage + 1}
                            </span>)  

                            if(index == pageArr.length-1 && pageArr?.length > 5) return (
                            <>
                                <>...</>
                                <span 
                                style={ ePage == currentPage ? {backgroundColor : "var(--activeP-back)", color : "var(--white-color)"} : {} } 
                                key={ePage} 
                                onClick={() => setCurrentPage(ePage)}
                                >
                                    {ePage + 1}
                                </span>
                            </>
                            )  

                            if(index == 0 && pageArr?.length > 5) return (
                            <>
                                <span 
                                style={ ePage == currentPage ? {backgroundColor : "var(--activeP-back)", color : "var(--white-color)"} : {} } 
                                key={ePage} 
                                onClick={() => setCurrentPage(ePage)}
                                >
                                    {ePage + 1}
                                </span>
                                <>...</>
                            </>)  

                        })} 
                        <button className={`${tableStyle.rBtn} ${tableStyle.btn}`}><RBtn/></button>
                    </div>
                </div>
            </>

            <SettingsModal
                open={openUpdateStateModal}
                cancel={handleCloseUpdateStateModal}
                maxWidth='480px'
                header='Update State'
                showrightIcon={false}
                content={<UpdateState 
                    stateId={stateId} 
                    handleClose={handleCloseUpdateStateModal} 
                    stateName={stateName}
                    data={getCountryData}
                    isLoading={countryIsLoading}
                    isError={countryIsError}
                    errorMessage={getCountryErrorMessage}
                    countryId={countryId}
                />}   
            />

            <SettingsModal
                open={openDeleteStateModal}
                cancel={handleCloseDeleteStateModal}
                maxWidth='653px'
                header='Delete State'
                showrightIcon={false}
                content={<DeleteState 
                    countryId={countryId} 
                    stateName={stateName}
                    stateId={stateId}
                    handleClose={handleCloseDeleteStateModal}
                />}   
            />
            
        </div>
    )
}

export default StateTable;

